import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { type NodeMouseHandler, useReactFlow } from '@xyflow/react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { type CustomNode } from './types'

const useNodeNavigation = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { fitView } = useReactFlow()

  const onNodeClick: NodeMouseHandler<CustomNode> = useCallback(
    (_, node: CustomNode) => {
      navigate(navigation.employees.jobCatalog.overview.node.fullPath({ id: node.id }))
      // This fitView call is to ensure the node is visible after the sidepanel is opened
      fitView({
        duration: 300,
        nodes: [node],
        maxZoom: 1,
        padding: { right: '70%', bottom: '60%' },
      })
    },
    [navigate, navigation, fitView]
  )

  return { onNodeClick }
}

export default useNodeNavigation
